<template>
  <div class="element-content">
    <div class="filter">
      <el-input type="text" v-model="query" placeholder="搜索">
        <i class="el-icon-search el-input__icon" slot="suffix"> </i>
      </el-input>
    </div>
    <div class="list">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          :title="item.Tag.name"
          :name="i + ''"
          :key="item.Tag.id"
          v-for="(item, i) in list"
        >
          <div class="content-img">
            <img
              v-for="value in item.ElementList"
              :src="value.image_url"
              alt=""
              @click="loadTemplate($event, value.image_url)"
              :key="value.id"
              draggable="true"
              @dragend="dragend"
              @dragstart="dragstart($event, value.image_url)"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import ListMixins from 'mixins/list';

export default {
  components: {},
  props: ['canvasWidth', 'canvasHeight'],
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'tagedElement',
      loading: false,
      query: '',
      category: null,
      activeNames: '0'
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    dragstart($event, data) {
      event.dataTransfer.setData('data', data);
      event.dataTransfer.setData('width', $event.target.naturalWidth);
      event.dataTransfer.setData('height', $event.target.naturalHeight);
    },
    dragend(event) {
      event.dataTransfer.clearData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    loadTemplate($event, data) {
      let img = new Image();
      img.src = data;
      const width = parseInt(img.width, 10);
      const height = parseInt(img.height, 10);
      this.$store.dispatch('elm_add', {
        type: 'image',
        width: width,
        height: height,
        isDynamic: 0,
        isCover: 0,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: data
      });
    },
    fetchNextPage() {
      if (!this.end && this.list.length) {
        this.$store.commit(this.namespace + '/update', {
          page: this.$store.state.element.page + 1
        });
        this.loading = true;
        this.$store.dispatch(this.namespace + '/fetchMore').then(() => {
          this.loading = false;
        });
      }
    },
    onWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN && direction === 'top') {
        this.fetchNextPage();
      }
    }
  },
  beforeDestroy() {
    this.$store.commit(this.namespace + '/update', {
      condition: {}
    });
  },
  watch: {
    query() {
      this.$store.commit(this.namespace + '/update', {
        condition: {
          tagName: this.query || undefined
        }
      });
      this.refreshData();
    }
  },
  computed: {
    list() {
      return this.$store.state[this.namespace].list || [];
    },
    tags() {
      return this.$store.state.tags.list || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.element-content {
  display: flex;
  flex-direction: column;
  width: 256px;
  height: calc(100vh - 60px);
  border-right: 1px solid #cfd3dd;
}

.item {
  overflow: hidden;
}

.filter {
  position: relative;
  display: flex;
  :global(input) {
    border: 0;
    height: 40px;
    line-height: 40px;
    flex: none;
    box-sizing: border-box;
    padding: 10px 12px;

    &::placeholder {
      color: #75808B;
      font-size: 14px;
    }
  }
  :global(.el-icon-search) {
    font-size: 20px;
    margin-right: 8px;
  }
}

.filter :global(.el-input) {
  width: 100%;
  border-bottom: 1px solid #cfd3dd;
  box-sizing: border-box;
}

.content-img {
  display: flex;
  overflow-x: hidden;
  flex-wrap: wrap;
  max-width: 100%;
  img {
    object-fit: contain;
    background: white;
    height: 100px;
    margin: 4px;
    flex-grow: 1;
    padding: 4px;
    border: 1px solid #e9edf0;
  }
  &:after {
    content: '';
    flex-grow: 9999;
  }
}

.list {
  width: 256px;
  padding: 0;
  flex: auto;
  overflow: auto;
  .item {
    cursor: pointer;
    margin-bottom: 20px;
  }
  .item .content {
    min-height: 10px;
    > :global(svg) {
      width: 100%;
      height: auto;
    }
  }
  .item .name {
    text-align: left;
    padding-bottom: 5px;
    color: #000;
  }
}
</style>
